import Cookies from 'universal-cookie';
import env from '../env';
import { extrairDominioPai } from './userCode';
import { getLocalStorage, LOCAL_STORAGE_KEY_ACCESS_TOKEN } from './localStorage';

/**
 * Recupera o token de autenticação da mesma forma que o interceptor do axios:
 * primeiro o cookie configurado, com fallback para o localStorage.
 */
export function getAuthToken(): string | null {
  const cookies = new Cookies(null, {
    path: '/',
    domain: extrairDominioPai(),
  });

  const cookieToken = cookies.get(env.REACT_APP_COOKIE_NAME);

  return cookieToken || getLocalStorage(LOCAL_STORAGE_KEY_ACCESS_TOKEN);
}
